import React, { useState } from "react";

function formatFileSize(sizeInBytes) {
  const kilobytes = sizeInBytes / 1024;
  return kilobytes.toFixed(2) + " KB";
}

function ClipboardCopy({ copyText, fileSize }) {
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(copyText)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <span className="file-size">{formatFileSize(fileSize)}</span>
      <span readOnly className="file-url">
        {copyText}
      </span>
      <a onClick={handleCopyClick} className="copy-btn">
        <span>
          {isCopied ? "Copied!" : <i className="fa-solid fa-copy"></i>}
        </span>
      </a>
    </>
  );
}

export default ClipboardCopy;
